/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const RightArrow: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="right-arrow" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 1133.3475L600.1 1053.4475L916.3 736.6949999999999H226.6525000000001V623.3475000000001H916.3L600.1 306.5950000000001L680 226.6950000000002L1133.3475 680.0425000000001L680 1133.39z" : "M544 906.678L480.08 842.758L733.0400000000001 589.356H181.3220000000001V498.6780000000001H733.0400000000001L480.08 245.2760000000001L544 181.3560000000001L906.6780000000002 544.0340000000001L544 906.7120000000002z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
RightArrow.displayName = `Blueprint5.Icon.RightArrow`;
export default RightArrow;
